module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('img', {
    staticClass: "info-icon pointer pull-right",
    attrs: {
      "src": "images/information.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.showInformation()
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Customize Your Order")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('catalog')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "shop-page-text"
  }, [_vm._v("\n                        Select an option below to customize your personalized message. For orders outside the contiguous United States (International, Alaska or Hawaii) please call 1-888-223-0291, and a customer service specialist will be happy to assist you. All materials subject to change based on final architectural design.\n                    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2887bb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shop.vue
// module id = Vg/4
// module chunks = 1